import { AppService } from './app.service';

export const services: any[] = [AppService];

export * from './app.service';
